/* ═══════════════════════════════════════════════════════════
   tessara-header.js — Mega menu, search overlay, cart drawer toggle
   Vanilla ES2020. No framework.
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  const header  = document.querySelector('.tds-header');
  const scrim   = document.querySelector('.tds-scrim');
  if (!header) return;

  /* ── Mega menu ── managed by inline script in header.liquid (window.tessaraMega) ── */

  let _focusTrapHandler = null;
  function trapFocus(el) {
    const focusable = Array.from(el.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])'));
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    _focusTrapHandler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last?.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first?.focus(); }
      }
    };
    el.addEventListener('keydown', _focusTrapHandler);
  }

  function releaseFocus(el) {
    if (_focusTrapHandler) {
      el.removeEventListener('keydown', _focusTrapHandler);
      _focusTrapHandler = null;
    }
  }

  /* ── Close triggers ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      window.tessaraMega?.close();
      closeSearch();
      closeCartDrawer();
    }
  });

  if (scrim) {
    scrim.addEventListener('click', () => {
      window.tessaraMega?.close();
      closeSearch();
      closeCartDrawer();
    });
  }

  /* ════════════════════════════════════
     Search overlay
  ════════════════════════════════════ */
  const searchOverlay  = document.querySelector('.tds-search-overlay');
  const searchBtn      = document.querySelector('[data-action="open-search"]');
  const searchInput    = searchOverlay?.querySelector('input[name="q"]');
  const searchResults  = document.getElementById('tds-search-results');
  const searchQuick    = document.getElementById('tds-search-quick');
  const searchClearBtn = document.querySelector('[data-action="clear-search"]');

  function openSearch() {
    if (!searchOverlay) return;
    // Reset state
    if (searchInput) { searchInput.value = ''; }
    if (searchClearBtn) { searchClearBtn.hidden = true; }
    if (searchQuick) { searchQuick.hidden = false; }
    if (searchResults) { searchResults.innerHTML = ''; }
    searchOverlay.hidden = false;
    document.getElementById('main-content')?.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.dataset.active = 'true';
    setTimeout(() => { searchInput?.focus(); trapFocus(searchOverlay); }, 80);
    // Close any open mega menu
    window.tessaraMega?.close();
  }

  function closeSearch() {
    if (!searchOverlay) return;
    releaseFocus(searchOverlay);
    searchOverlay.hidden = true;
    if (!isCartOpen()) document.getElementById('main-content')?.removeAttribute('aria-hidden');
    if (scrim && !isCartOpen() && !document.querySelector('[data-mega-panel][data-open="true"]')) scrim.dataset.active = 'false';
    searchBtn?.focus();
  }

  document.querySelectorAll('[data-action="open-search"]').forEach((btn) => {
    btn.addEventListener('click', openSearch);
  });

  document.querySelectorAll('[data-action="close-search"]').forEach((btn) => {
    btn.addEventListener('click', closeSearch);
  });

  // Clear button (× inside search bar)
  searchClearBtn?.addEventListener('click', () => {
    if (searchInput) { searchInput.value = ''; searchInput.focus(); }
    if (searchClearBtn) { searchClearBtn.hidden = true; }
    if (searchQuick) { searchQuick.hidden = false; }
    if (searchResults) { searchResults.innerHTML = ''; }
  });

  // Quick search chips
  document.querySelectorAll('[data-fill-search]').forEach((chip) => {
    chip.addEventListener('click', () => {
      if (!searchInput) return;
      searchInput.value = chip.textContent.trim();
      searchInput.dispatchEvent(new Event('input'));
      searchInput.focus();
    });
  });

  // Live search (debounced 250ms)
  let searchDebounce = null;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchDebounce);
    const q = searchInput.value.trim();
    // Toggle clear button and quick searches
    if (searchClearBtn) { searchClearBtn.hidden = q.length === 0; }
    if (searchQuick) { searchQuick.hidden = q.length > 0; }
    if (q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchDebounce = setTimeout(() => fetchSuggestions(q), 250);
  });

  async function fetchSuggestions(q) {
    try {
      const url = `/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&limit=6&section_id=predictive-search`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('suggest-fail');
      const html = await res.text();
      if (searchResults) searchResults.innerHTML = html;
    } catch {
      if (searchResults) {
        searchResults.innerHTML = `<a href="/collections/all" class="tds-search-fallback">Browse all patterns &rarr;</a>`;
      }
    }
  }

  // Keyboard navigation in search results
  searchInput?.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const firstResult = searchResults?.querySelector('a, button');
      firstResult?.focus();
    }
  });

  /* ════════════════════════════════════
     Cart drawer toggle (open/close only;
     content loading is in tessara-cart.js)
  ════════════════════════════════════ */
  const cartDrawer    = document.getElementById('cart-drawer');
  const cartIconBtn   = document.querySelector('[data-action="open-cart"]');
  const cartCloseBtn  = document.getElementById('cart-drawer-close');

  function isCartOpen() {
    return cartDrawer?.dataset.open === 'true';
  }

  window.openCartDrawer = function () {
    if (!cartDrawer) return;
    cartDrawer.dataset.open = 'true';
    document.getElementById('main-content')?.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.dataset.active = 'true';
    cartCloseBtn?.focus();
    trapFocus(cartDrawer);
  };

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.dataset.open = 'false';
    document.getElementById('main-content')?.removeAttribute('aria-hidden');
    if (scrim && !document.querySelector('[data-mega-panel][data-open="true"]') && !searchOverlay?.offsetParent) scrim.dataset.active = 'false';
    releaseFocus(cartDrawer);
    cartIconBtn?.focus();
  }

  document.querySelectorAll('[data-action="open-cart"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (isCartOpen()) { closeCartDrawer(); } else { openCartDrawer(); }
    });
  });

  cartCloseBtn?.addEventListener('click', closeCartDrawer);

  /* ── Tab visibility: refresh cart badge ── */
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      window.tessaraCart?.refreshBadge?.();
    }
  });

})();
